import { VFS, FileInfo } from '@/api/types'
import { parse } from 'fast-xml-parser'

const body = `<?xml version="1.0" encoding="utf-8" ?>
<propfind xmlns="DAV:"
  xmlns:in="http://sapportals.com/xmlns/cm/webdav">
  <allprop/>
</propfind>`

export class Webdav implements VFS {
  private source: string
  constructor (source: string, config?: { [key: string]: string }) {
    this.source = source
  }

  // TODO: asi nebude fungovat Stat nad adresari
  async Stat (path: string): Promise<FileInfo> {
    // console.log('Webdav.Stat', path)
    const headers: HeadersInit = new Headers()
    headers.set('Content-Type', 'application/xml; charset="utf-8"')
    headers.set('Depth', '1')

    const opts: RequestInit = {
      method: 'PROPFIND',
      headers,
      body: body
    }

    const requestUrl = new URL(path.slice(1), this.source).href
    const res = await this.fetch(requestUrl, opts)
    if (!res) {
      throw new Error('can\'t get content')
    }
    const text = res
    const root: any = parse(text, {
      ignoreAttributes: false,
      ignoreNameSpace: true
    })

    if (Array.isArray(root.multistatus.response)) {
      return {
        Name: path.slice(1, -1).split('/').pop() || '',
        ContentType: '',
        IsDir: true
      }
    }

    const props: any = root.multistatus.response.propstat.prop
    const input: FileInfo = {
      Name: props.displayname,
      IsDir: !props.getcontenttype,
      ContentType: props.getcontenttype || 'Directory',
      XAttr: {
        LastModification: props.getlastmodified
      }
    }

    return input
  }

  private async fetch (input: RequestInfo, init?: RequestInit): Promise<string | undefined> {
    return fetch(input, init).then((res: Response) => {
      if (!window.caches) {
        return res.text()
      }
      return caches.open('webdav-cache').then((c: Cache) => {
        return c.put(input, res.clone()).then(() => {
          return res.text()
        })
      })
    }).catch(async () => {
      console.warn(`Error while fetching ${input}. Trying use cache`)
      const c = await caches.open('webdav-cache')
      const res = await c.match(input)
      return res?.text()
    })
  }

  async ResolveFilename (path: string): Promise<string> {
    // console.log('Webdav.ResolveFilename', path)

    const [, filename] = path.split('/')
    const headers: HeadersInit = new Headers()
    headers.set('Content-Type', 'application/xml; charset="utf-8"')
    headers.set('Depth', '1')

    const opts: RequestInit = {
      method: 'PROPFIND',
      headers,
      body: body
    }

    const requestUrl = new URL(path.slice(1), this.source).href
    const res = await this.fetch(requestUrl, opts)
    if (!res) {
      throw new Error('can\'t get content')
    }
    const text = res
    const root = parse(text, {
      ignoreAttributes: false,
      ignoreNameSpace: true
    })

    if (!Array.isArray(root.multistatus.response)) {
      root.multistatus.response = [root.multistatus.response]
    }
    const file: any = root.multistatus.response.find((item: any) => {
      const props: any = item.propstat.prop
      // Neni adresar nebo se jmena nerovnaji
      return props.getcontenttype || props.displayname !== filename
    })
    return new Promise<string>((resolve) => {
      resolve(file.href)
    })
  }

  async ReadDir (path: string): Promise<FileInfo[]> {
    // console.log('Webdav.ReadDir', path)
    if (path.slice(-1) !== '/') {
      throw new Error(`${path} is not directory`)
    }

    const headers: HeadersInit = new Headers()
    headers.set('Content-Type', 'application/xml; charset="utf-8"')
    headers.set('Depth', '1')

    const opts: RequestInit = {
      method: 'PROPFIND',
      headers,
      body: body
    }

    const requestUrl = new URL(path.slice(1), this.source).href
    const res = await this.fetch(requestUrl, opts)
    if (!res) {
      throw new Error('can\'t get content')
    }
    const text = res
    const root: any = parse(text, {
      ignoreAttributes: false,
      ignoreNameSpace: true
    })

    if (!Array.isArray(root.multistatus.response)) {
      root.multistatus.response = [root.multistatus.response]
    }

    // TODO: check array undefined
    const input: FileInfo[] = root.multistatus.response.map((item: any) => {
      const props: any = item.propstat.prop
      return {
        Name: props.displayname,
        IsDir: !props.getcontenttype,
        ContentType: props.getcontenttype || 'Directory',
        XAttr: {
          LastModification: props.getlastmodified
        }
      }
    })

    // Odebere prvni vraceny adresar, protoze je to aktualni adresar, ktery nechceme zobrazovat
    return input.slice(1)
  }
}
